export type ParamDefinition = {
    key: string;
    label: string;
    type: 'text' | 'url';
    placeholder?: string;
};

export type ComponentDefinition = {
    label: string;
    params: ParamDefinition[];
};

export const COMPONENT_REGISTRY: Record<string, ComponentDefinition> = {
    Match: {
        label: 'Match',
        params: [],
    },
    Mp4TransitionMatchWidget: {
        label: 'MP4 Transition Match Widget',
        params: [],
    },
    Bet: {
        label: 'Bet',
        params: [],
    },
    DraftKingsLogoBanner: {
        label: 'DraftKings Logo Banner',
        params: [],
    },
    Download: {
        label: 'Download',
        params: [
            { key: 'sport', label: 'Sport', type: 'text', placeholder: 'e.g. current' },
        ],
    },
    UrlContent: {
        label: 'URL Content',
        params: [
            { key: 'contentUrl', label: 'Content URL', type: 'url', placeholder: 'https://' },
        ],
    },
    UrlMarquee: {
        label: 'URL Marquee (live data)',
        params: [
            { key: 'contentUrl', label: 'Content URL', type: 'url', placeholder: 'https://' },
        ],
    },
    Suds: {
        label: 'Suds',
        params: [],
    },
    Betting101: {
        label: 'Betting 101',
        params: [],
    },
    FeaturedPropBet: {
        label: 'Featured Prop Bet',
        params: [],
    },
    Debug: {
        label: 'Debug',
        params: [],
    },
    VideoTest: {
        label: 'Video Test',
        params: [],
    },
    Marquee: {
        label: 'Marquee',
        params: [],
    },
};

export const CLOUD_UI_PLUGIN_ID = 'cloud-ui-v1' as const;

export const PLUGIN_IDS = [
    { value: 'draft-kings-v1', label: 'DraftKings v1' },
    { value: 'fanduel-v1', label: 'FanDuel v1' },
    { value: CLOUD_UI_PLUGIN_ID, label: 'Cloud UI' },
];

export const COMPONENT_OPTIONS = Object.entries(COMPONENT_REGISTRY).map(([value, { label }]) => ({
    value,
    label,
}));
